import { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { clearSession, getUser } from '../api.js';
import { Logo } from './Logo.jsx';

const NavItem = ({ to, children }) => (
  <NavLink
    to={to}
    end
    className={({ isActive }) => `nav-link ${isActive ? 'nav-link-active' : 'nav-link-idle'}`}
  >
    {children}
  </NavLink>
);

export default function Layout({ children }) {
  const navigate = useNavigate();
  const user = getUser();
  const [adminOpen, setAdminOpen] = useState(false);

  const logout = () => {
    clearSession();
    navigate('/login');
  };

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-40 border-b border-line/60 backdrop-blur-md bg-paper/75">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-3 shrink-0">
            <Logo size={36} withWordmark={false} />
            <div className="hidden sm:block leading-none">
              <div className="font-bold tracking-tight text-[15px]">LibroContable</div>
              <div className="font-mono text-[9px] uppercase tracking-[0.18em] text-muted mt-1">{user?.nombre ?? 'SLC S.A.S'}</div>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-1 relative">
            <NavItem to="/">Hoy</NavItem>
            <NavItem to="/horario">Horario</NavItem>
            <NavItem to="/servicios">Servicios</NavItem>
            <NavItem to="/vender">Vender</NavItem>
            <NavItem to="/cuadre">Cuadre</NavItem>
            <NavItem to="/reportes">Reportes</NavItem>
            {user?.rol === 'admin' && (
              <div className="relative">
                <button
                  onClick={() => setAdminOpen((o) => !o)}
                  className={`nav-link nav-link-idle ${adminOpen ? 'bg-bone' : ''}`}
                >
                  Admin <span className="text-[9px] opacity-60">▾</span>
                </button>
                {adminOpen && (
                  <div className="absolute right-0 mt-2 w-60 bg-paper rounded-2xl shadow-lg border border-line/80 p-2 z-50" style={{ boxShadow: '0 24px 48px -16px rgba(27,42,78,0.25)' }}>
                    <Link to="/admin/usuarios" onClick={() => setAdminOpen(false)} className="block px-3 py-2 rounded-xl font-medium text-sm hover:bg-bone transition">
                      <div className="flex items-center justify-between"><span>Usuarios</span><span className="font-mono text-[9px] uppercase tracking-[0.16em] text-muted">PIN · rol</span></div>
                    </Link>
                    <Link to="/admin/unidades" onClick={() => setAdminOpen(false)} className="block px-3 py-2 rounded-xl font-medium text-sm hover:bg-bone transition">
                      <div className="flex items-center justify-between"><span>Unidades</span><span className="font-mono text-[9px] uppercase tracking-[0.16em] text-muted">habitaciones</span></div>
                    </Link>
                    <Link to="/productos" onClick={() => setAdminOpen(false)} className="block px-3 py-2 rounded-xl font-medium text-sm hover:bg-bone transition">
                      <div className="flex items-center justify-between"><span>Productos</span><span className="font-mono text-[9px] uppercase tracking-[0.16em] text-muted">precios · fotos</span></div>
                    </Link>
                    <Link to="/admin/tenants" onClick={() => setAdminOpen(false)} className="block px-3 py-2 rounded-xl font-medium text-sm hover:bg-bone transition">
                      <div className="flex items-center justify-between"><span>Empresas</span><span className="font-mono text-[9px] uppercase tracking-[0.16em] text-muted">multi-cliente</span></div>
                    </Link>
                    <div className="border-t border-line my-1"></div>
                    <Link to="/cuenta" onClick={() => setAdminOpen(false)} className="block px-3 py-2 rounded-xl font-medium text-sm hover:bg-bone transition">
                      <div className="flex items-center justify-between"><span>Mi cuenta</span><span className="font-mono text-[9px] uppercase tracking-[0.16em] text-muted">cambiar PIN</span></div>
                    </Link>
                  </div>
                )}
              </div>
            )}
          </nav>

          <div className="flex items-center gap-2">
            {user?.rol && (
              <Link to="/cuenta" className="hidden sm:inline-flex pill-ink hover:bg-ink-soft transition">{user.rol}</Link>
            )}
            <button onClick={logout} className="btn-ghost text-muted hover:text-ink">
              Salir
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-10 pb-28 md:pb-12">
        {children}
      </main>

      <nav className="md:hidden fixed bottom-0 inset-x-0 bg-paper/95 backdrop-blur-md border-t border-line z-40">
        <div className="grid grid-cols-5 gap-1 p-2">
          <NavItem to="/">Hoy</NavItem>
          <NavItem to="/servicios">Hab.</NavItem>
          <NavItem to="/vender">Vender</NavItem>
          <NavItem to="/cuadre">Cuadre</NavItem>
          <NavItem to="/reportes">Rep</NavItem>
        </div>
      </nav>
    </div>
  );
}
